import * as React from 'react';
import Strings from '../../../translations/strings';
import Card from '../Card/Card';
import { Stack, IStackTokens } from '@fluentui/react';
import { cards } from './cards';
import styles from './CardContainer.module.css';
import UAParser from 'ua-parser-js';

interface CardContainerProps {
    eWayVersion: string;
}

const wrapStackTokens: IStackTokens = { childrenGap: 20 };

const uaParser = new UAParser();

const CardContainer: React.FC<CardContainerProps> = ({ eWayVersion }) => {
    return (
        <section className={styles.cardContainer}>
            <h2 className={styles.title}>{Strings.components.cardContainer.title}</h2>
            <Stack horizontal verticalAlign="center" horizontalAlign="center" wrap tokens={wrapStackTokens}>
                {cards.map((card) => {
                    if (card.id === 1 && uaParser.getOS().name !== 'Windows') {
                        // Hide install card if the OS is not Windows
                        return null;
                    }
                    return (
                        <Card
                            key={card.id}
                            {...card}
                            eWayVersion={eWayVersion}
                            displayInFirstPosition={card.id === 3 && uaParser.getDevice()?.type === 'mobile'}
                        />
                    );
                })}
            </Stack>
        </section>
    );
};

export default CardContainer;
